type Listener = () => void;

const TEN_MINUTES = 10;

class AppVersionUpdates {
  private readonly intervalInMs: number;
  private previousHtml: string | undefined;
  private intervalId: number | undefined;
  private hasChanged = false;
  private listeners: Set<Listener> = new Set();

  constructor(intervalInMinutes: number) {
    this.intervalInMs = intervalInMinutes * 60 * 1000;
  }

  private async getLastVersion(): Promise<string | undefined> {
    try {
      const response = await fetch('/index.html', { cache: 'no-store' });
      return response.text();
    } catch {
      return this.previousHtml;
    }
  }

  private checkUpdates() {
    this.getLastVersion().then((html) => {
      if (this.previousHtml && this.previousHtml !== html) {
        this.hasChanged = true;
        this.listeners.forEach((listener: Listener) => {
          listener();
        });
        this.stopInterval();
      }
      this.previousHtml = html;
    });
  }

  public addListener(listener: Listener): void {
    this.listeners.add(listener);
  }

  public runInterval() {
    this.getLastVersion().then((html) => {
      this.previousHtml = html;
    });
    if (this.intervalId === undefined) {
      this.intervalId = window.setInterval(() => this.checkUpdates(), this.intervalInMs);
    }
  }

  public stopInterval() {
    if (this.intervalId !== undefined) {
      clearInterval(this.intervalId);
      this.intervalId = undefined;
    }
  }

  public async isNewerVersion(): Promise<boolean> {
    if (this.hasChanged) {
      return true;
    }
    if (!this.previousHtml) {
      return false;
    }
    try {
      const html = await this.getLastVersion();
      return this.previousHtml !== html;
    } catch (error) {
      return false;
    }
  }
}

export const appVersionUpdates = new AppVersionUpdates(TEN_MINUTES);
